<template>
  <div v-if="sharedObject.linked_objects && sharedObject.linked_objects.length > 0">
    <div v-for="lo in sharedObject.linked_objects" :key="'reltxt' + lo.id" class="related_list sm_bdmark_off" :id="'relo_' + lo.id">
      <v-expansion-panel>
        <v-expansion-panel-content>
          <div v-if="lo['meta']['Quellenangabe']" slot="header" :id="'list_o_' + lo.id">
            <div v-if="lo.subject_item_type === 'Bilddokument'" class="s__cat">
              {{ translate['Bilddokument'][lang]  }}
            </div>
            <div v-else class="s__cat">
              {{ translate['Textquelle'][lang]  }}
            </div>
            <div v-html="'' + lo['meta']['Quellenangabe']"></div>
          </div>
          <div v-else-if="lo['meta']['Sigle Quelle ID'] && metaSources[lo['meta']['Sigle Quelle ID']].meta['Ausgabe-Format']" slot="header" :id="'list_o_' + lo.id">
            <div v-if="lo.subject_item_type === 'Bilddokument'" class="s__cat">
              {{ translate['Bilddokument'][lang]  }}
            </div>
            <div v-else class="s__cat">
              {{ translate['Textquelle'][lang]  }}
            </div>
            <div v-html="'' + metaSources[lo['meta']['Sigle Quelle ID']].meta['Ausgabe-Format']"></div>
          </div>
          <div v-else-if="lo['meta']['Sigle Quelle ID'] && metaSources[lo['meta']['Sigle Quelle ID']].meta['Bezeichnung']" slot="header" :id="'list_o_' + lo.id">
            <div v-if="lo.subject_item_type === 'Bilddokument'" class="s__cat">
              {{ translate['Bilddokument'][lang]  }}
            </div>
            <div v-else class="s__cat">
              {{ translate['Textquelle'][lang]  }}
            </div>
            <div v-html="'' + metaSources[lo['meta']['Sigle Quelle ID']].meta['Bezeichnung']"></div>
          </div>
          <div v-else-if="lo['meta']['Angabe Online-Quelle, Bezeichnung']" slot="header" :id="'list_o_' + lo.id">
            <div v-if="lo.subject_item_type === 'Bilddokument'" class="s__cat">
              {{ translate['Bilddokument'][lang]  }}
            </div>
            <div v-else class="s__cat">
              {{ translate['Textquelle'][lang]  }}
            </div>
            <div v-html="'' + lo['meta']['Angabe Online-Quelle, Bezeichnung']"></div>
          </div>
          <div v-else-if="lo['meta']['Title'] && lo.subject_item_type !== 'Transaktion'" slot="header" :id="'list_o_' + lo.id">
              <div class="s__cat">
              {{ translate['allgemeine Quelle'][lang]  }}
            </div>
            <div v-html="'' + lo['meta']['Title']"></div>
          </div>
          <div v-if="lo.subject_item_type === 'Bilddokument' && lo.meta.filename" class="list_thn">
            <img
              :src="'https://www.mari-portal.de/omeka/files/square_thumbnails/' + lo.meta.filename.toLowerCase()"
              :alt="(lo.meta['Bildlegende']) ? lo.meta['Bildlegende'] : lo.meta['filename']">
          </div>
          <div class="dbox">
            <div class="nos_source" v-if="lo['meta']['Seite in Quelle'] || lo['meta']['Nr. in Quelle']">
              <template v-if="lo['meta']['Seite in Quelle']">
                <span class="s__cat">{{ translate['Seite in Quelle'][lang] }}</span>
                <span class="s__value pr-4" v-html="lo['meta']['Seite in Quelle']"></span>
              </template>
              <template v-if="lo['meta']['Nr. in Quelle']">
                <span class="s__cat">{{ translate['Nr. in Quelle'][lang] }}</span>
                <span class="s__value" v-html="lo['meta']['Nr. in Quelle']"></span>
              </template>
            </div>
              <template v-if="lo['meta']['Verweis Abbildung']">
                <div class="s__cat">{{ translate['Verweis Abbildung'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Verweis Abbildung']"></div>
              </template>
              <template v-if="lo['meta']['Titel']">
                <div class="s__cat">{{ translate['Titel'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Titel']"></div>
              </template>
              <template v-if="lo['meta']['Weitere Angaben']">
                <div class="s__cat">{{ translate['Weitere Angaben'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Weitere Angaben']"></div>
              </template>
              <template v-if="lo['meta']['Material und Technik']">
                <div class="s__cat">{{ translate['Material und Technik'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Material und Technik']"></div>
              </template>
              <template v-if="lo['meta']['Maße']">
                <div class="s__cat">{{ translate['Maße'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Maße']"></div>
              </template>
              <template v-if="lo['meta']['Beschreibung']">
                <div class="s__cat">{{ translate['Beschreibung'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Beschreibung']"></div>
              </template>
              <template v-if="lo['meta']['Information Zustand, Beschaffenheit']">
                <div class="s__cat">{{ translate['Information Zustand, Beschaffenheit'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Information Zustand, Beschaffenheit']"></div>
              </template>
              <template v-if="lo['meta']['Rubrik']">
                <div class="s__cat">{{ translate['Rubrik'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Rubrik']"></div>
              </template>
              <template v-if="lo['meta']['Rahmen']">
                <div class="s__cat">{{ translate['Rahmen'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Rahmen']"></div>
              </template>
              <template v-if="lo['meta']['Signatur']">
                <div class="s__cat">{{ translate['Signatur'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Signatur']"></div>
              </template>
              <template v-if="lo['meta']['Datierung']">
                <div class="s__cat">{{ translate['Datierung'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Datierung']"></div>
              </template>
              <template v-if="lo['meta']['Erwerbung durch Mosse']">
                <div class="s__cat">{{ translate['Erwerbung durch Mosse'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Erwerbung durch Mosse']"></div>
              </template>
              <template v-if="lo['meta']['Angabe Besitzer/Eigentümer']">
                <div class="s__cat">{{ translate['Angabe Besitzer/Eigentümer'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Angabe Besitzer/Eigentümer']"></div>
              </template>
              <template v-if="lo['meta']['Angabe Vorbesitzer']">
                <div class="s__cat">{{ translate['Angabe Vorbesitzer'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Angabe Vorbesitzer']"></div>
              </template>
              <template v-if="lo['meta']['Referenz']">
                <div class="s__cat">{{ translate['Referenz'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Referenz']"></div>
              </template>
              <template v-if="lo['meta']['Bildlegende']">
                <div class="s__cat">{{ translate['Bildlegende'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Bildlegende']"></div>
              </template>
              <template v-if="lo['meta']['Bildrechte-Angabe']">
                <div class="s__cat">{{ translate['Bildrechte'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Bildrechte-Angabe']"></div>
              </template>
              <template v-if="lo['meta']['Angabe Online-Quelle, Bezeichnung']
                && lo['meta']['Angabe Online-Quelle, URL']">
                <div class="s__cat">{{ translate['Online-Quelle'][lang] }}</div>
                <div class="s__value">
                  <a :href="lo['meta']['Angabe Online-Quelle, URL']" target="_blank" v-html="lo['meta']['Angabe Online-Quelle, Bezeichnung']"></a>
                </div>
              </template>
              <template v-if="lo['meta']['Nachricht über das Werk']">
                <div class="s__cat">{{ translate['Nachricht über das Werk'][lang] }}</div>
                <div class="s__value" v-html="lo['meta']['Nachricht über das Werk']"></div>
              </template>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-divider></v-divider>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SourcesList',
  props: ['sharedObject', 'translate', 'lang', 'metaSources'],
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/partials/SourcesList.vue